import React, { FC, useEffect } from 'react';
import { Modal, Stack } from 'src/components';
import Lottie from 'lottie-react';
import { defineMessages, useIntl } from 'react-intl';
import { defaultAnimationOptions } from 'src/components/constants';
import * as S from './styles';
import sync from './sync.json';

const msgs = defineMessages({
  header: {
    id: 'ea_switch_sync_screen_line1',
    defaultMessage: 'Sync in Progress',
  },
  text: {
    id: 'ea_switch_sync_screen_line2',
    defaultMessage: 'This may take up to a few minutes. Please do not close or refresh this page.',
  },
});

export const MIN_TIME = 3000; // 3 seconds
export const MAX_TIME = 600000; // 10 minutes

export const SyncLoader: FC<{
  isOpen: boolean;
  stopProcess: boolean;
  setOpenModal: (isOpen: boolean) => void;
  onClose?: () => void;
  fullSize?: boolean;
  header?: string;
  description?: string;
}> = ({ isOpen, stopProcess, setOpenModal, onClose = () => {}, fullSize, header, description }) => {
  const intl = useIntl();

  useEffect(() => {
    const timeoutIdMin = setTimeout(() => {
      if (stopProcess) {
        setOpenModal(false);
        onClose();
      }
    }, MIN_TIME);

    const timeoutIdMax = setTimeout(() => {
      if (stopProcess) {
        setOpenModal(false);
        onClose();
      }
    }, MAX_TIME);
    return () => {
      clearTimeout(timeoutIdMin);
      clearTimeout(timeoutIdMax);
    };
  }, [onClose, setOpenModal, stopProcess]);

  return (
    <Modal isOpen={isOpen} hideCloseButton fullSize={fullSize} shouldCloseOnEsc={false}>
      <Stack $direction="vertical" $align="center" $paddingX="s6" $paddingY="s8" $spacing="s4">
        <S.AnimationContainer data-testid="SyncLoader-animation">
          <Lottie {...defaultAnimationOptions} loop animationData={sync} />
        </S.AnimationContainer>
        <S.Header data-testid="SyncLoader-header">
          {header || intl.formatMessage(msgs.header)}
        </S.Header>
        <S.Text data-testid="SyncLoader-text">
          {description || intl.formatMessage(msgs.text)}
        </S.Text>
      </Stack>
    </Modal>
  );
};
